module.exports = __webpack_public_path__ + "static/media/webecomm.a4aec921.png";